﻿// Extends jQuery validation to attach Bootstrap error classes to the form-group. Use with Bootstrap 3
// and jQuery validation 1.11.

(function ($) {
    $.validator.setDefaults({
        highlight: function (element) {

            // Add error class to enclosing .form-group, or to parent element if none.
            var wrapper = $(element).closest('.form-group');
            if (wrapper.length === 0)
                wrapper = $(element).parent();
            wrapper.addClass('has-error');
        },
        unhighlight: function (element) {
            $(element).closest('.has-error').removeClass('has-error');
        },
        errorElement: 'span',
        errorClass: 'help-block',
        errorPlacement: function (error, element) {
            if (element.parent('.input-group').length || element.prop('type') === 'checkbox' || element.prop('type') === 'radio') {
                error.insertAfter(element.parent());
            } else {
                error.insertAfter(element);
            }
        }
    });

    $(document).ready(function () {
        $(".field-validation-error").each(function () {
            var p = $(this).closest('.form-group');
            if (p.length === 0) p = $(this).parent();
            p.addClass('has-error');
        });
    });

})(jQuery);


